import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminPricing from "@/pages/AdminPricing";
import WorkOrdersList from "@/pages/admin/WorkOrdersList";
import WorkOrderEditor from "@/pages/admin/WorkOrderEditor";
import Employees from "@/pages/admin/Employees";
import PilotDashboard from "@/pages/pilot/PilotDashboard";
import PilotJobDetail from "@/pages/pilot/PilotJobDetail";
import SeoLandingPage from "@/pages/seo/SeoLandingPage";
import UltimateGuide from "@/pages/seo/UltimateGuide";
import BlogIndex from "@/pages/blog/BlogIndex";
import BlogPost from "@/pages/blog/BlogPost";
import "@/App.css";

const getRole = () => {
  try { return JSON.parse(localStorage.getItem("aero_user") || "{}").role; } catch { return null; }
};

const RequireAuth = ({ children, role }) => {
  const token = localStorage.getItem("aero_token");
  if (!token) return <Navigate to="/login" replace />;
  const userRole = getRole();
  if (role && userRole !== role) {
    return <Navigate to={userRole === "pilot" ? "/pilot" : "/admin"} replace />;
  }
  return children;
};

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />

          {/* SEO landing pages */}
          <Route path="/drone-crop-spraying-homestead-fl" element={<SeoLandingPage configKey="homestead-fl" />} />
          <Route path="/drone-crop-spraying-homestead-fl/" element={<SeoLandingPage configKey="homestead-fl" />} />
          <Route path="/drone-crop-spraying-miami-dade" element={<SeoLandingPage configKey="miami-dade" />} />
          <Route path="/drone-crop-spraying-miami-dade/" element={<SeoLandingPage configKey="miami-dade" />} />
          <Route path="/agricultural-drone-spraying-redland-fl" element={<SeoLandingPage configKey="redland-fl" />} />
          <Route path="/agricultural-drone-spraying-redland-fl/" element={<SeoLandingPage configKey="redland-fl" />} />
          <Route path="/drone-spraying-avocado-groves" element={<SeoLandingPage configKey="avocado-groves" />} />
          <Route path="/drone-spraying-avocado-groves/" element={<SeoLandingPage configKey="avocado-groves" />} />
          <Route path="/farm-drone-spraying-cost-florida" element={<SeoLandingPage configKey="cost-florida" />} />
          <Route path="/farm-drone-spraying-cost-florida/" element={<SeoLandingPage configKey="cost-florida" />} />
          <Route path="/drone-pesticide-spraying-florida" element={<SeoLandingPage configKey="pesticide-florida" />} />
          <Route path="/drone-pesticide-spraying-florida/" element={<SeoLandingPage configKey="pesticide-florida" />} />
          <Route path="/herbicide-drone-application-miami" element={<SeoLandingPage configKey="herbicide-miami" />} />
          <Route path="/herbicide-drone-application-miami/" element={<SeoLandingPage configKey="herbicide-miami" />} />
          <Route path="/fungicide-drone-treatment-homestead" element={<SeoLandingPage configKey="fungicide-homestead" />} />
          <Route path="/fungicide-drone-treatment-homestead/" element={<SeoLandingPage configKey="fungicide-homestead" />} />

          {/* Local service-area pages */}
          <Route path="/homestead-drone-spraying" element={<SeoLandingPage configKey="homestead-area" />} />
          <Route path="/homestead-drone-spraying/" element={<SeoLandingPage configKey="homestead-area" />} />
          <Route path="/miami-drone-agriculture" element={<SeoLandingPage configKey="miami-agriculture" />} />
          <Route path="/miami-drone-agriculture/" element={<SeoLandingPage configKey="miami-agriculture" />} />
          <Route path="/broward-county-drone-farming" element={<SeoLandingPage configKey="broward-area" />} />
          <Route path="/broward-county-drone-farming/" element={<SeoLandingPage configKey="broward-area" />} />
          <Route path="/florida-city-crop-spraying" element={<SeoLandingPage configKey="florida-city-area" />} />
          <Route path="/florida-city-crop-spraying/" element={<SeoLandingPage configKey="florida-city-area" />} />
          <Route path="/citrus-drone-spraying-florida" element={<SeoLandingPage configKey="citrus-florida" />} />
          <Route path="/citrus-drone-spraying-florida/" element={<SeoLandingPage configKey="citrus-florida" />} />
          <Route path="/nursery-drone-application-florida" element={<SeoLandingPage configKey="nursery-florida" />} />
          <Route path="/nursery-drone-application-florida/" element={<SeoLandingPage configKey="nursery-florida" />} />

          <Route path="/drone-spraying-florida-guide" element={<UltimateGuide />} />
          <Route path="/drone-spraying-florida-guide/" element={<UltimateGuide />} />

          {/* Blog */}
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/blog/:slug/" element={<BlogPost />} />

          <Route path="/login" element={<AdminLogin />} />

          {/* Admin */}
          <Route path="/admin" element={<RequireAuth role="admin"><AdminDashboard /></RequireAuth>} />
          <Route path="/admin/pricing" element={<RequireAuth role="admin"><AdminPricing /></RequireAuth>} />
          <Route path="/admin/work-orders" element={<RequireAuth role="admin"><WorkOrdersList /></RequireAuth>} />
          <Route path="/admin/work-orders/:id" element={<RequireAuth role="admin"><WorkOrderEditor /></RequireAuth>} />
          <Route path="/admin/employees" element={<RequireAuth role="admin"><Employees /></RequireAuth>} />

          {/* Pilot */}
          <Route path="/pilot" element={<RequireAuth role="pilot"><PilotDashboard /></RequireAuth>} />
          <Route path="/pilot/jobs/:id" element={<RequireAuth role="pilot"><PilotJobDetail /></RequireAuth>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton offset={20} />
    </>
  );
}
